const notification = {
  state: {
    message: null,
    isError: false,
    isSuccess: false,
  },
  reducers: {
    clearAll(state) {
      return {
        ...state,
        message: null,
        isError: false,
        isSuccess: false,
      };
    },
    setErrorMessage(state, payload) {
      return {
        ...state,
        message: payload,
        isError: true,
        isSuccess: false,
      };
    },
    setSuccessMessage(state, payload) {
      return {
        ...state,
        message: payload,
        isError: false,
        isSuccess: true,
      };
    },
  },
};

export default notification;
